import {BasicController, BasicModel, BasicUserEvent} from "@goodgamestudios/core";
import {SFConstants} from "../../../constants/SFConstants";
import {Poker2AvatarEvent} from "../../../event/Poker2AvatarEvent";
import {Poker2UserEvent} from "../../../event/Poker2UserEvent";
import {AvatarVO} from "../../../gamevo/AvatarVO";
import {Poker2Model} from "../../../model/Poker2Model";
import {DispHelper} from "../../helper/DispHelper";
import {Poker2TutorialController} from "../../../controller/Poker2TutorialController";
import {AvatarHolder} from "../../helper/AvatarHolder";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
import {Poker2ShopScreen} from "../Poker2ShopScreen";
import { Timer } from "@goodgamestudios/createjs-utilities";

import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;
import TimerEvent = createjs.TimerEvent;
import {Poker2TextFieldHelper} from "../../helper/Poker2TextFieldHelper";

export class AvatarLobbyDetailComponent {
    private _holder: Container;
    private _view: Library.PokerInterface.LobbyAvatarDetailView;
    private _timer: Timer;

    constructor(holder: Container) {
        this._holder = holder;
        this._view = new Library.PokerInterface.LobbyAvatarDetailView();
        this._holder.addChild(this._view);

        this._view.mc_avatar.uncache();
        this._holder.changeTextFieldCacheScale(2);
        this._view.bg.doCache();

        this.initTextfields();
        this.enable();
    }

    public enable(): void {
        this.controller.addEventListener("avatarChanged", this.bindFunction(this.onChangeAvatar));
        this.controller.addEventListener("avatarReset", this.bindFunction(this.onChangeAvatar));
        this.controller.addEventListener("avatarClothesChanged", this.bindFunction(this.onChangeTempAvatar));
        this.controller.addEventListener("changeUserdata", this.bindFunction(this.onChangeUserData));
        this.controller.addEventListener("changeUserXP", this.bindFunction(this.onChangeUserData));
        this.controller.addEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onChangeUserData));
        this._view.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onMouseOver));
        this._view.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onMouseOut));

        this._view.btn_inventar.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        this._view.btn_profil.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
    }

    public disable(): void {
        this.controller.removeEventListener("avatarChanged", this.bindFunction(this.onChangeAvatar));
        this.controller.removeEventListener("avatarReset", this.bindFunction(this.onChangeAvatar));
        this.controller.removeEventListener("avatarClothesChanged", this.bindFunction(this.onChangeTempAvatar));
        this.controller.removeEventListener("changeUserdata", this.bindFunction(this.onChangeUserData));
        this.controller.removeEventListener("changeUserXP", this.bindFunction(this.onChangeUserData));
        this.controller.removeEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onChangeUserData));
        this._view.removeEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onMouseOver));
        this._view.removeEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onMouseOut));

        this._view.btn_inventar.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        this._view.btn_profil.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
    }

    public destroy(): void {
        this.disable();
        this._holder = null;
        this._view = null;
    }

    private onMouseOver() {
        if(this._timer && this._timer.running) {
            this._timer.stop();
            this._timer.removeEventListener(TimerEvent.TIMER,this.bindFunction(this.onZoomOutTimerCompleted));
        }
        this._view.mc_avatar.uncache();
    }

    private onMouseOut() {
        // Wait till the avatar's zoom has been completely restored to it's initial state
        this._timer = new Timer(1000, 1);
        this._timer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onZoomOutTimerCompleted));
        this._timer.start();
    }

    private onZoomOutTimerCompleted(event: TimerEvent): void {
        (event.target as Timer).stop();
        (event.target as Timer).removeEventListener(TimerEvent.TIMER,this.bindFunction(this.onZoomOutTimerCompleted));
        this._view.mc_avatar.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    private initTextfields(): void {
        this._view.btn_inventar.label = Poker2Model.languageData.getTextById("shop_btn_inventory");
        this._view.btn_profil.label = Poker2Model.languageData.getTextById("menu_btn_statistics");
        this._view.btn_inventar.toolTipText = Poker2Model.languageData.getTextById("menu_btn_inventar");
        this._view.btn_profil.toolTipText = Poker2Model.languageData.getTextById("menu_btn_statistics");
        this._view.txt_name.text = Poker2Model.userData.userName;
        this._view.txt_rang.text = Poker2Model.userData.generateTitle(Poker2Model.userData.userLevel);
        Poker2TextFieldHelper.changeTextFromatSizeByMaxHeight(8, this._view.mc_xp.txt_level, String(Poker2Model.userData.userLevel));
    }

    private onChangeTempAvatar(event: Poker2AvatarEvent): void {
        this.updateAvatar(event.params[0]);
    }

    private onChangeAvatar(event: Poker2AvatarEvent): void {
        this.updateAvatar(Poker2Model.avatarData.myAvatar);
    }

    private onChangeUserData(event: Event): void {
        this.updateName(Poker2Model.userData.userName);
        this.updateRank(Poker2Model.userData.generateTitle(Poker2Model.userData.userLevel));
        this.updateLevel(Poker2Model.userData.userLevel.toString());
    }

    protected onClick(event: MouseEvent): void {
        if (this.tutorialController.isActive)
            return;

        switch (event.target.name) {
            case "btn_inventar":

                Poker2LayoutManager.getInstance().state = 13;
                BasicController.getInstance().dispatchEvent(new Poker2UserEvent("changeShopState", ["stateInventory"]));
                break;

            case "btn_profil":

                var paramObject: any = {id: Poker2Model.userData.playerID};
                BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
                break;
        }
    }

    public updateAvatar(avatarVO: AvatarVO): void {
        DispHelper.removeAllChildrenOf(this._view.mc_avatar.mc_holder);

        var mcAvatar: Container = new AvatarHolder(avatarVO);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        var scaleFactor: number = 240 / bounds.width;

        if ((bounds.height * scaleFactor) > 240)
            scaleFactor = 240 / bounds.height;
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = -((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor)) - 2;

        this._view.mc_avatar.mc_holder.addChild(mcAvatar);
        this._view.mc_avatar.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    public updateName(userName: string): void {
        this._view.txt_name.text = userName;
    }

    public updateRank(rank: string): void {
        this._view.txt_rang.text = rank;
    }

    public updateLevel(level: string): void {
        this._view.mc_xp.txt_level.text = level;
    }

    public get view(): Library.PokerInterface.LobbyAvatarDetailView {
        return this._view;
    }

    public set view(value: Library.PokerInterface.LobbyAvatarDetailView) {
        this._view = value;
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }
}
